export const getConfig = () => {
  const storageState = localStorage.getItem('RadioSDK:config');
  return typeof storageState === 'string' ? JSON.parse(storageState) : {};
};
